export const experiences = [
  {
    id: "private-tours",
    title: "Private Curated Tours",
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "Bespoke",
    short: "A single party, a private guide, a journey written for you alone.",
    description: "Every Voyage Luxe itinerary is private by design. No groups, no fixed departures — only your party, your pace, and a personal concierge who anticipates the next chapter before you ask for it.",
  },
  {
    id: "honeymoon",
    title: "Honeymoon Journeys",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "Romance",
    short: "Overwater villas, sandbank dinners, and chapters of quiet between.",
    description: "From the Maldives and Santorini to a tented camp in the Thar, we have orchestrated the first nights of married life for more than two thousand couples. Surprises arranged with discretion.",
  },
  {
    id: "desert-camping",
    title: "Desert Luxury Camping",
    image: "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "Thar & Beyond",
    short: "Cinematic tented suites under skies untouched by light.",
    description: "Our partner camps in Jaisalmer and Sam dunes are dismantled and rebuilt each season. Private sitar evenings, Michelin-trained chefs, and astronomers who know every star by name.",
  },
  {
    id: "yacht",
    title: "Yacht & Cruise Journeys",
    image: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "Open Sea",
    short: "Charter a private yacht along the Amalfi, the Maldives, or the Andamans.",
    description: "From day-sails to month-long voyages — we curate the route, the crew, the chef, and the secret coves few captains know.",
  },
  {
    id: "wellness",
    title: "Wellness Retreats",
    image: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "Restoration",
    short: "Ayurveda in Kerala, Six Senses in Bhutan, COMO in Phuket.",
    description: "We build wellness journeys around a diagnostic consultation. Sleep, nutrition, movement, spirit — woven into a programme you'll take home.",
  },
  {
    id: "concierge",
    title: "VIP Concierge",
    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=1600&q=80&auto=format&fit=crop",
    eyebrow: "On Demand",
    short: "From sold-out reservations to a closed museum at midnight.",
    description: "Voyage Luxe maintains a 24/7 concierge desk for clients in residence. Tables at The Fat Duck, after-hours at the Vatican, courtside Wimbledon — we make the impossible feel inevitable.",
  },
];
